var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{key:_vm.data.key || _vm.data.text,class:[
    'column',
    _vm.data.sortable ? 'sortable' : '',
    _vm.asc ? 'asc' : 'desc',
    _vm.data.orderBy === _vm.orderBy ? 'active' : '',
    _vm.data.align ? 'text-xs-' + _vm.data.align : '' ],attrs:{"width":_vm.data.width,"title":_vm.titleText},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.data.text)+" "),(_vm.data.sortable)?_c('v-icon',{attrs:{"small":""}},[_vm._v("arrow_upward")]):_vm._e(),_c('span',{staticClass:"d-block",class:_vm.thFooterClass},[_vm._v(_vm._s(_vm.thFooterText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }